import axios from "axios";
import { Grid } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import "./AddNewPhase.css";
import { fetchStates, fetchStyles } from "../../redux/actions/filterActions";
import VerticalLinearStepper from "../VerticalLinearStepper/VerticalLinearStepper";
import AddNewPhasePage from "./Pages/AddNewPhasePage";
import { fetchPhaseTypes } from "../../redux/actions/addPhaseTypeActions";
import { useParams } from "react-router-dom";
import { isRequestingRole, isLenderRole, isProjectRole, isProjectStandardRole, isReadonlyRole, isTPORole } from "../../redux/actions/userAction";
import { initLenderRequest, projectInfoResult, selectRequestSubTypesByName } from "../../redux/actions/lenderRequestActions";
import RequestNewPhasePage from "./Pages/RequestNewPhasePage";
import SuccessPage from "./Pages/SuccessPage";
import { useEffect, useMemo, useState } from "react";
import AttachmentsPage from "../EditPhase/pages/AttachmentsPage";
import ProjectInfoBanner from "../SharedComponents/ProjectInfoBanner/ProjectInfoBanner";

const AddNewPhase = () => {
  if((!isRequestingRole() && !isProjectRole()) || isReadonlyRole()) {
    location.replace("/unauthorized");
    return null;
  }

  const { project_id: projectId } = useParams();

  const steps = useMemo(() => {
    return isProjectRole()
      ? ["Add New Phase", "Final Confirmation"]
      : ["Request New Phase", "Attach Documents", "Final Confirmation"];
  }, []);

  const [projectInfo, setProjectInfo] = useState();
  const [stepCount, setStepCount] = useState(0);
  const [newPhase, setNewPhase] = useState("");
  const [requestCallback, setRequestCallback] = useState();
  const [formState, setFormState] = useState({});

  const decrementCounter = (formState) => {
    if (formState) {
      setFormState(formState);
    }
    setStepCount(stepCount - 1);
  }
  
  const incrementCounter = (formState, requestCallback) => {
    if (requestCallback) {
      setRequestCallback({callBack: requestCallback});
    }
    if (formState) {
      setFormState(formState);
    }
    setStepCount(stepCount + 1);
  }

  const requestId = useSelector(store => store.lenderRequestReducer.requestId);  

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchStates());
    dispatch(fetchPhaseTypes());
    window.scrollTo(0, 0);

    (async () => {
      const projectInfo = await getProjectDetailsById(projectId);
      setProjectInfo(projectInfo);

      if (!isProjectRole()) {
        await dispatch(initLenderRequest("Lender Add Phase"));
        dispatch(selectRequestSubTypesByName(["New Phase"]));
      }
    })();
  }, []);

  useEffect(() => {
    if (projectInfo) {
      dispatch(projectInfoResult(projectInfo));
    }
  }, [projectInfo]);
  
  async function getProjectDetailsById(projectId) {
    const projectJson = localStorage.getItem("project" + [projectId]);
    if (projectJson) {
      const projectInfo = JSON.parse(projectJson);
      console.log("Project info from localStorage:", projectInfo);
      return projectInfo;
    }

    const { data: project } = await axios.get(
      global.REACT_APP_API_ENDPOINT +
      `/condoMgr/getProjectDetailsByProjectId/` +
      projectId
    );

    if (project === `Cannot find project:${projectId}`) {
      console.error(project);
      return;
    }

    return project.projectProfile;
  }

  const getPage = () => {
    if (isProjectStandardRole()) {
      switch (stepCount) {
        case 0:
          return (
            <AddNewPhasePage
              incStepCounter={incrementCounter}
              decStepCounter={decrementCounter}
              addPhase={setNewPhase}
            />
          );
        case 1:
          return (
            <SuccessPage
              msg={`A new phase ${newPhase} has been added!`}
              projectId={projectId}
            />
          );
      }
    } else {
      switch (stepCount) {
        case 0:
          return (
            <RequestNewPhasePage
              incStepCounter={incrementCounter}
              projectInfo={projectInfo}
              formState={formState}
            />
          );
        case 1:
          return (
            <AttachmentsPage
              phaseId={null} // todo: Seems correct since there are multiple phases, but double check
              projectId={projectId}
              requestCallback={requestCallback?.callBack}
              incrementCounter={incrementCounter}
              decrementCounter={decrementCounter}
              formState={formState}
            />
          );
        case 2:
          return (
            <SuccessPage
              msg={`A new Add Phase Request has been submitted!`}
              projectId={projectId}
            />
          );
      }
    }

    return "";
  };

  return (
    <Grid container>
      <Grid item xs={3} style={{ backgroundColor: "#F2F2F2" }}>
        <VerticalLinearStepper
          steps={steps}
          activeStep={stepCount}
        />
      </Grid>
      <Grid
        container
        item
        xs={9}
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        style={{ padding: "20px", border: "solid 1px black" }}
      >
        {!isProjectRole() && (
          <ProjectInfoBanner projectId={projectId} projectName={projectInfo?.projectName} />
        )}
        {getPage()}
      </Grid>
    </Grid>
  );
};

export default AddNewPhase;
